import { makeStyles } from '@lifeomic/chroma-react/styles';

export const useMemberDetailStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    minWidth: 0,
  },
  pageLayout: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  pageRoot: {
    height: '100%',
    padding: 0,
  },
  layoutContainer: {
    flex: 1,
    minHeight: 0,
    marginBottom: 0,
  },
  headerBackgroundPadding: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    minHeight: 0,
  },
  backgroundCover: {
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 0,
  },
  headerName: {
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headerDob: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headerMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  elationLink: {
    whiteSpace: 'nowrap',
  },
  elationLinkContent: {
    ...theme.typography.caption,
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  contentArea: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
  menuActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'center',
    flex: '1 1 0',
    minWidth: 0,
    maxWidth: '100%',
    '@media (max-width: 959.95px)': {
      order: 0,
      flexBasis: 'auto',
      margin: 0,
    },
  },
  menuButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: 0,
    whiteSpace: 'nowrap',
    position: 'relative',
    left: theme.spacing(-4),
  },
  menuLabelText: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  menuItemSelected: {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  contentLayout: {
    display: 'flex',
    gap: theme.spacing(1),
    flex: 1,
    minHeight: 0,
    alignItems: 'stretch',
    position: 'relative',
  },
  mainContent: {
    flex: 1,
    minWidth: 0,
    height: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  chatWrapper: {
    display: 'flex',
    alignSelf: 'stretch',
    height: '100%',
    marginLeft: 'auto',
    position: 'relative',
    flex: '0 0 auto',
  },
  chatWrapperOverlay: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 100,
    marginLeft: 0,
    boxShadow: theme.boxShadows.elevatedContent,
  },
  chatWrapperFullscreen: {
    position: 'fixed',
    inset: 0,
    zIndex: 1300,
    marginLeft: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: theme.palette.common.white,
  },
  chatResizable: {
    height: '100%',
    display: 'flex',
  },
  chatResizableFullscreen: {
    width: '100%',
    height: '100%',
  },
  chatSidebar: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  chatSidebarFullscreen: {
    borderLeft: 'none',
  },
  chatHeader: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  chatContent: {
    flex: 1,
    minHeight: 0,
  },
  resizeHandle: {
    backgroundColor: theme.palette.primary.main,
    cursor: 'ew-resize',
    height: '100%',
    opacity: 0,
    position: 'absolute',
    left: 0,
    top: 0,
    width: 3,
    zIndex: 1000,
    '&:hover': {
      opacity: 1,
      transition: 'opacity 0.2s ease-out',
    },
  },
}));
